
import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";

const AZUL = "#328AC4";

const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingHorizontal: 20,
    paddingBottom: 48,
    fontSize: 6,
    fontFamily: "Helvetica",
    color: "#252525",
  },

  logoContainer: {
    marginBottom: 6,
  },

  logo: {
    width: 120,
  },

  titleContainer: {
    alignItems: "center",
    marginBottom: 15,
  },

  titleText: {
    fontSize: 14,
    fontWeight: "bold",
    color: AZUL,
    textAlign: "center",
  },

  orderText: {
    marginTop: 3,
    fontSize: 8,
    color: "#666666",
    textAlign: "center",
  },

  sectionHeader: {
    marginTop: 5,
    marginBottom: 4,
    paddingBottom: 2,
    borderBottomWidth: 0.7,
    borderBottomColor: AZUL,
  },

  sectionTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: AZUL,
  },

  table: {
    marginBottom: 9,
    borderWidth: 0.7,
    borderColor: "#D5DCE3",
    borderRadius: 3,
  },

  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#EEF3F7",
    paddingVertical: 4,
    paddingHorizontal: 2,
    borderBottomWidth: 0.5,
    borderBottomColor: "#D5DCE3",
  },

  tableRow: {
    flexDirection: "row",
    paddingVertical: 4,
    paddingHorizontal: 2,
    borderBottomWidth: 0.3,
    borderBottomColor: "#E8E8E8",
  },

  tableRowLast: {
    flexDirection: "row",
    paddingVertical: 4,
    paddingHorizontal: 2,
  },

  headerText: {
    fontWeight: "bold",
    color: "#333333",
  },

  colRut: {
    width: "11%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colNombre: {
    width: "18%",
    paddingHorizontal: 3,
  },

  colFecha: {
    width: "14%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colTelefono: {
    width: "12%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colDireccion: {
    width: "18%",
    paddingHorizontal: 3,
  },

  colEmail: {
    width: "19%",
    paddingHorizontal: 3,
  },

  colNacimiento: {
    width: "8%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colFamilia: {
    width: "14%",
    paddingHorizontal: 3,
  },

  colTipo: {
    width: "15%",
    paddingHorizontal: 3,
  },

  colMarca: {
    width: "13%",
    paddingHorizontal: 3,
  },

  colModelo: {
    width: "15%",
    paddingHorizontal: 3,
  },

  colSerie: {
    width: "15%",
    paddingHorizontal: 3,
  },

  colServicio: {
    width: "22%",
    paddingHorizontal: 3,
  },

  colHora: {
    width: "6%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colIndex: {
    width: "7%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colTestItem: {
    width: "69%",
    paddingHorizontal: 4,
  },

  colCheck: {
    width: "12%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colGarantiaItem: {
    width: "57%",
    paddingHorizontal: 4,
  },

  colGarantiaCheck: {
    width: "12%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  checkBox: {
    width: 10,
    height: 10,
    borderWidth: 0.7,
    borderColor: "#7B8794",
    borderRadius: 1,
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
  },

  checkBoxActive: {
    backgroundColor: AZUL,
    borderColor: AZUL,
  },

  checkMark: {
    color: "#FFFFFF",
    fontSize: 7,
    fontWeight: "bold",
  },

  observationBox: {
    minHeight: 38,
    marginBottom: 9,
    padding: 6,
    backgroundColor: "#F8FAFC",
    borderWidth: 0.7,
    borderColor: "#D5DCE3",
    borderRadius: 3,
  },

  observationText: {
    fontSize: 7,
    lineHeight: 1.4,
  },

  conditionsBox: {
    marginTop: 4,
    marginBottom: 12,
    padding: 7,
    backgroundColor: "#F8FAFC",
    borderLeftWidth: 2,
    borderLeftColor: AZUL,
  },

  conditionsTitle: {
    fontSize: 7.5,
    fontWeight: "bold",
    color: AZUL,
    marginBottom: 4,
  },

  conditionsText: {
    fontSize: 6,
    color: "#555555",
    lineHeight: 1.4,
    textAlign: "justify",
    marginBottom: 3,
  },

  signatureSection: {
    position: "absolute",
    bottom: 65,
    left: 20,
    right: 20,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  signatureBox: {
    width: "42%",
    alignItems: "center",
  },

  signatureLine: {
    width: "100%",
    borderTopWidth: 0.7,
    borderTopColor: "#777777",
    marginBottom: 4,
  },

  signatureName: {
    fontSize: 7,
    fontWeight: "bold",
    textAlign: "center",
  },

  signatureRole: {
    marginTop: 2,
    fontSize: 6,
    color: "#555555",
    textAlign: "center",
  },

  signatureArea: {
    marginTop: 1,
    fontSize: 6,
    color: "#777777",
    textAlign: "center",
  },

  footer: {
    position: "absolute",
    bottom: 16,
    left: 20,
    right: 20,
    flexDirection: "row",
    borderTopWidth: 0.5,
    borderTopColor: "#DDDDDD",
    paddingTop: 4,
    color: "#666666",
    fontSize: 5.5,
  },

  footerContact: {
    width: "80%",
  },

  footerPage: {
    width: "20%",
    textAlign: "right",
  },

  noData: {
    padding: 7,
    fontSize: 6.5,
    color: "#777777",
    textAlign: "center",
  },

  // Reserva invisible para garantizar que
  // las firmas no se superpongan al contenido.
  signatureReservation: {
    height: 105,
  },
});

const safeText = (value, fallback = "-") => {
  if (
    value === null ||
    value === undefined ||
    value === ""
  ) {
    return fallback;
  }

  return String(value);
};

const formatearFecha = (fecha, incluirHora = true) => {
  if (!fecha) return "-";

  try {
    let dateObj;

    if (typeof fecha?.toDate === "function") {
      dateObj = fecha.toDate();
    } else if (fecha instanceof Date) {
      dateObj = fecha;
    } else if (fecha?.seconds) {
      dateObj = new Date(fecha.seconds * 1000);
    } else {
      dateObj = new Date(fecha);
    }

    if (Number.isNaN(dateObj.getTime())) {
      return "-";
    }

    return moment(dateObj).format(
      incluirHora
        ? "DD/MM/YYYY HH:mm"
        : "DD/MM/YYYY"
    );
  } catch {
    return "-";
  }
};

const SectionTitle = ({ children }) => (
  <View
    style={styles.sectionHeader}
    minPresenceAhead={30}
  >
    <Text style={styles.sectionTitle}>
      {children}
    </Text>
  </View>
);

const Check = ({ checked }) => (
  <View style={styles.checkBox}>
    {checked && (
      <Image
        src="../../check.png"
        style={{
          width: 8,
          height: 8,
        }}
      />
    )}
  </View>
);

const Footer = () => (
  <View style={styles.footer} fixed>
    <Text style={styles.footerContact}>
      soporte@dormirbien.cl | General Parra #674 Oficina H,
      Providencia | +56 9 7632 1481 / +56 9 5423 4538
    </Text>

    <Text
      style={styles.footerPage}
      render={({ pageNumber, totalPages }) =>
        `Página ${pageNumber} de ${totalPages}`
      }
    />
  </View>
);

const Firmas = ({ nombreUsuario, entidad }) => (
  <View style={styles.signatureSection}>
    <View style={styles.signatureBox}>
      <View style={styles.signatureLine} />

      <Text style={styles.signatureName}>
        {nombreUsuario.toUpperCase()}
      </Text>

      <Text style={styles.signatureRole}>
        Responsable del ingreso
      </Text>

      <Text style={styles.signatureArea}>
        Servicio Técnico
      </Text>
    </View>

    <View style={styles.signatureBox}>
      <View style={styles.signatureLine} />

      <Text style={styles.signatureName}>
        {safeText(entidad, "CLIENTE").toUpperCase()}
      </Text>

      <Text style={styles.signatureRole}>
        Aceptación del cliente
      </Text>

      <Text style={styles.signatureArea}>
        Orden de Ingreso
      </Text>
    </View>
  </View>
);

const Condiciones = () => (
  <View style={styles.conditionsBox} wrap={false}>
    <Text style={styles.conditionsTitle}>
      Condiciones del Servicio Técnico
    </Text>

    <Text style={styles.conditionsText}>
      Los equipos reparados deberán ser retirados dentro
      de 30 días corridos, y los equipos irreparables o
      dados de baja dentro de 15 días corridos desde la
      notificación.
    </Text>

    <Text style={styles.conditionsText}>
      Los equipos que no sean retirados dentro de estos
      plazos serán desechados, sin derecho a reclamo
      posterior.
    </Text>

    <Text style={styles.conditionsText}>
      De acuerdo con el artículo 42 de la Ley Nº 19.496,
      si el equipo no es retirado dentro de los plazos
      acordados, se entenderá abandonado en favor del
      proveedor, pudiendo disponerse de él conforme a
      la normativa vigente y políticas internas.
    </Text>
  </View>
);

const TablaCliente = ({ cabecera }) => (
  <>
    <SectionTitle>Datos del Cliente</SectionTitle>

    <View style={styles.table} wrap={false}>
      <View style={styles.tableHeader}>
        <Text style={[styles.colRut, styles.headerText]}>
          Rut
        </Text>
        <Text style={[styles.colNombre, styles.headerText]}>
          Nombre
        </Text>
        <Text style={[styles.colFecha, styles.headerText]}>
          Fecha
        </Text>
        <Text style={[styles.colTelefono, styles.headerText]}>
          Teléfono
        </Text>
        <Text style={[styles.colDireccion, styles.headerText]}>
          Dirección
        </Text>
        <Text style={[styles.colEmail, styles.headerText]}>
          Email
        </Text>
        <Text style={[styles.colNacimiento, styles.headerText]}>
          F. Nac.
        </Text>
      </View>

      <View style={styles.tableRowLast}>
        <Text style={styles.colRut}>
          {safeText(cabecera.rut)}
        </Text>
        <Text style={styles.colNombre}>
          {safeText(cabecera.entidad)}
        </Text>
        <Text style={styles.colFecha}>
          {formatearFecha(cabecera.date)}
        </Text>
        <Text style={styles.colTelefono}>
          {safeText(cabecera.telefono)}
        </Text>
        <Text style={styles.colDireccion}>
          {safeText(cabecera.direccion)}
        </Text>
        <Text style={styles.colEmail}>
          {safeText(cabecera.correo)}
        </Text>
        <Text style={styles.colNacimiento}>
          {cabecera.fnaci
            ? formatearFecha(cabecera.fnaci, false)
            : "-"}
        </Text>
      </View>
    </View>
  </>
);

const TablaEquipo = ({ cabecera }) => (
  <>
    <SectionTitle>Datos del Equipo</SectionTitle>

    <View style={styles.table} wrap={false}>
      <View style={styles.tableHeader}>
        <Text style={[styles.colFamilia, styles.headerText]}>
          Familia
        </Text>
        <Text style={[styles.colTipo, styles.headerText]}>
          Tipo
        </Text>
        <Text style={[styles.colMarca, styles.headerText]}>
          Marca
        </Text>
        <Text style={[styles.colModelo, styles.headerText]}>
          Modelo
        </Text>
        <Text style={[styles.colSerie, styles.headerText]}>
          Serie
        </Text>
        <Text style={[styles.colServicio, styles.headerText]}>
          Servicio
        </Text>
        <Text style={[styles.colHora, styles.headerText]}>
          Hrs.
        </Text>
      </View>

      <View style={styles.tableRowLast}>
        <Text style={styles.colFamilia}>
          {safeText(cabecera.familia)}
        </Text>
        <Text style={styles.colTipo}>
          {safeText(cabecera.tipo)}
        </Text>
        <Text style={styles.colMarca}>
          {safeText(cabecera.marca)}
        </Text>
        <Text style={styles.colModelo}>
          {safeText(cabecera.modelo)}
        </Text>
        <Text style={styles.colSerie}>
          {safeText(cabecera.serie)}
        </Text>
        <Text style={styles.colServicio}>
          {safeText(cabecera.servicio)}
        </Text>
        <Text style={styles.colHora}>
          {safeText(cabecera.horamaquina)}
        </Text>
      </View>
    </View>
  </>
);

const TablaTest = ({ titulo, items, garantia = false }) => {
  if (!items.length) {
    if (garantia) return null;

    return (
      <>
        <SectionTitle>{titulo}</SectionTitle>
        <View style={styles.table}>
          <Text style={styles.noData}>
            No se registraron ítems en el Test de Ingreso.
          </Text>
        </View>
      </>
    );
  }

  return (
    <>
      <SectionTitle>{titulo}</SectionTitle>

      <View style={styles.table}>
        <View style={styles.tableHeader}>
          <Text style={[styles.colIndex, styles.headerText]}>
            N°
          </Text>

          <Text
            style={[
              garantia
                ? styles.colGarantiaItem
                : styles.colTestItem,
              styles.headerText,
            ]}
          >
            Ítem
          </Text>

          <Text
            style={[
              garantia
                ? styles.colGarantiaCheck
                : styles.colCheck,
              styles.headerText,
            ]}
          >
            Sí
          </Text>

          <Text
            style={[
              garantia
                ? styles.colGarantiaCheck
                : styles.colCheck,
              styles.headerText,
            ]}
          >
            No
          </Text>

          {garantia && (
            <Text
              style={[
                styles.colGarantiaCheck,
                styles.headerText,
              ]}
            >
              Revisión
            </Text>
          )}
        </View>

        {items.map((item, index) => (
          <View
            key={item.id || item.item_id || index}
            style={
              index === items.length - 1
                ? styles.tableRowLast
                : styles.tableRow
            }
            wrap={false}
          >
            <Text style={styles.colIndex}>
              {index + 1}
            </Text>

            <Text
              style={
                garantia
                  ? styles.colGarantiaItem
                  : styles.colTestItem
              }
            >
              {safeText(
                item.item ||
                item.nombretest ||
                item.nombre
              )}
            </Text>

            <View
              style={
                garantia
                  ? styles.colGarantiaCheck
                  : styles.colCheck
              }
            >
              <Check checked={item.valorsi === true} />
            </View>

            <View
              style={
                garantia
                  ? styles.colGarantiaCheck
                  : styles.colCheck
              }
            >
              <Check checked={item.valorno === true} />
            </View>

            {garantia && (
              <View style={styles.colGarantiaCheck}>
                <Check checked={item.revision === true} />
              </View>
            )}
          </View>
        ))}
      </View>
    </>
  );
};

const Observaciones = ({ texto }) => (
  <>
    <SectionTitle>Observaciones</SectionTitle>

    <View style={styles.observationBox} wrap={false}>
      <Text style={styles.observationText}>
        {safeText(texto, "Sin observaciones.")}
      </Text>
    </View>
  </>
);

// Estimación conservadora para decidir
// si el documento necesita dos páginas.
// No altera los datos ni los ítems.
const requiereDosPaginas = (
  test,
  testGpdf,
  observaciones
) => {
  const filas =
    (test?.length || 0) +
    (testGpdf?.length || 0);

  const textoObservaciones = String(
    observaciones || ""
  );

  return (
    filas > 18 ||
    textoObservaciones.length > 450
  );
};

const SimplePDF = ({
  props = [],
  test = [],
  testGpdf = [],
  usuario = [],
  empresa = "",
}) => {
  const cabecera = props?.[0] || {};

  const usuarioPdf = usuario?.[0] || {
    nombre: "Sistema",
    apellido: "LogisticMed",
    correo: "",
  };

  const nombreUsuario =
    `${safeText(usuarioPdf.nombre, "")} ${safeText(
      usuarioPdf.apellido,
      ""
    )}`.trim() ||
    safeText(usuarioPdf.correo, "Servicio Técnico");

  const dosPaginas = requiereDosPaginas(
    test,
    testGpdf,
    cabecera.observaciones
  );

  const Encabezado = () => (
    <>
      <View style={styles.logoContainer}>
        {empresa ? (
          <Image
            src={`../../${empresa}.png`}
            style={styles.logo}
          />
        ) : null}
      </View>

      <View style={styles.titleContainer}>
        <Text style={styles.titleText}>
          ORDEN DE INGRESO
        </Text>

        <Text style={styles.orderText}>
          Orden N° {safeText(cabecera.folio)}
        </Text>
      </View>
    </>
  );

  return (
    <Document>
      {!dosPaginas ? (
        <Page
          size="LETTER"
          style={styles.page}
          wrap={false}
        >
          <Encabezado />

          <TablaCliente cabecera={cabecera} />
          <TablaEquipo cabecera={cabecera} />

          <TablaTest
            titulo="Test de Ingreso"
            items={test}
          />

          <TablaTest
            titulo="Test de Garantía"
            items={testGpdf}
            garantia
          />

          <Observaciones
            texto={cabecera.observaciones}
          />

          <Condiciones />

          <View style={styles.signatureReservation} />

          <Firmas
            nombreUsuario={nombreUsuario}
            entidad={cabecera.entidad}
          />

          <Footer />
        </Page>
      ) : (
        <>
          <Page
            size="LETTER"
            style={styles.page}
            wrap
          >
            <Encabezado />

            <TablaCliente cabecera={cabecera} />
            <TablaEquipo cabecera={cabecera} />

            <TablaTest
              titulo="Test de Ingreso"
              items={test}
            />

            <TablaTest
              titulo="Test de Garantía"
              items={testGpdf}
              garantia
            />

            <Footer />
          </Page>

          <Page
            size="LETTER"
            style={styles.page}
            wrap={false}
          >
            <SectionTitle>
              Observaciones
            </SectionTitle>

            <View style={styles.observationBox}>
              <Text style={styles.observationText}>
                {safeText(
                  cabecera.observaciones,
                  "Sin observaciones."
                )}
              </Text>
            </View>

            <Condiciones />

            <View style={styles.signatureReservation} />

            <Firmas
              nombreUsuario={nombreUsuario}
              entidad={cabecera.entidad}
            />

            <Footer />
          </Page>
        </>
      )}
    </Document>
  );
};

export default SimplePDF;
